import { optionsProps } from 'types';
import { attendedOptions, rsvpOptions } from 'utils/pairGuestFilters';

export type SingleRoleGuestFilterKey = 'rsvp' | 'attended';

export type SingleRoleGuestFilters = Record<SingleRoleGuestFilterKey, string[]>;

export interface SingleRoleGuestFilterGroup {
  key: SingleRoleGuestFilterKey;
  label: string;
  options: optionsProps[];
}

export const EMPTY_SINGLE_ROLE_GUEST_FILTERS: SingleRoleGuestFilters = {
  rsvp: [],
  attended: [],
};

export const SINGLE_ROLE_RSVP_FILTER_GROUP: SingleRoleGuestFilterGroup = {
  key: 'rsvp',
  label: 'RSVP',
  options: rsvpOptions,
};

export const SINGLE_ROLE_ATTENDED_FILTER_GROUP: SingleRoleGuestFilterGroup = {
  key: 'attended',
  label: 'Attended',
  options: attendedOptions,
};

export const singleRoleGuestFilterGroup = (isAttendanceFinalized: boolean) =>
  isAttendanceFinalized ? SINGLE_ROLE_ATTENDED_FILTER_GROUP : SINGLE_ROLE_RSVP_FILTER_GROUP;

// Mentor-only and mentee-only events are filtered server-side. The API does not pick the active
// group from the event's finalized state, so only the group on screen is sent — any values left
// over in the other group stay out of the request.
export const singleRoleGuestFiltersPayload = (filters: SingleRoleGuestFilters, isAttendanceFinalized: boolean) => {
  const { key } = singleRoleGuestFilterGroup(isAttendanceFinalized);
  return { [key]: filters[key] };
};
